import axios from "axios";
import React, { useEffect, useState } from "react";
import { Button, Col, Form, Modal, Row } from "react-bootstrap";
import * as Icon from "react-bootstrap-icons";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Select from "react-select";
import { useDispatch, useSelector } from "react-redux";
import useGetAllCategories from "../ReuseApi/useGetAllCategories";
import useGetAllProjects from "../ReuseApi/useGetAllProjects";
import { useNavigate } from "react-router-dom";
import useGetSubDepartments from "../ReuseApi/useGetSubDepartments";
import { taskPriorityOptions } from "../../utils/constant";
import { useProjectList } from "../ReuseApi/useProjectList ";

export const AssignNoTaskModel = ({ show, close, data }) => {
  const loginUserData = useSelector((state) => state.loginData.userData);

  const navigate = useNavigate();
  const dispatch = useDispatch();

  // employee departments
  const userDepartmentName = (data?.department || []).map((itm) => ({
    label: itm.label,
    value: itm.value,
  }));

  // states
  const [taskpriority, setTaskpriority] = useState("");
  const [projectname, setProjectname] = useState("");
  const [categoryname, setCategoryname] = useState("");
  const [departmentName, setDepartmentName] = useState(null);
  const [subDepartment, setSubDepartment] = useState(null);

  // custom hook
  const { subDeptOptions } = useGetSubDepartments(departmentName?.value);
  const { allCategoriesOptions } = useGetAllCategories(departmentName, subDepartment);
  const { projectOptions, departmentOptions } = useProjectList(projectname?.value, data?.empId);

  const [addnotask, setAddNoTask] = useState({
    empId: "",
    taskId: "",
    taskName: "",
    taskdescription: "",
    department_id: "",
    departmentName: "",
    subDepartment: "",
    AssignTask: "",
    assignBy_id: "",
    assignby: "",
    assignto: "",
    assigntoid: "",
    proposedstartdate: "",
    proposedenddate: "",
    initialEstimateHr: "",
    initialEstimateMinutes: "",
    estimatehr: "",
    logStatus: {
      resource_id: "",
      resourceName: "",
    },
  });

  // errors
  const [tasktitleerror, setTaskTitleError] = useState(false);
  const [taskdescerror, setTaskDescError] = useState(false);
  const [taskcategoryError, setTaskCategoryError] = useState(false);
  const [taskprojnameerror, setTaskProjNameError] = useState(false);
  const [taskpriorityerror, setTaskPriorityError] = useState(false);
  const [taskproposeddterror, setTaskProposedDtError] = useState(false);
  const [taskproposedenddterror, setTaskProposedEndDtError] = useState(false);
  const [taskinitialestihrerror, setTaskInitialEstimateHrError] = useState(false);
  const [initialminuteErr, setInitialMinuteErr] = useState(false);
  const [departmentError, setDepartmentError] = useState(false);
  const [subDepartmentError, setSubDepartmentError] = useState(false);

  // default department select
  useEffect(() => {
    if (userDepartmentName.length > 0 && !departmentName) {
      setDepartmentName(userDepartmentName[0]);
    }
  }, [data]);

  const handlerValidate = () => {
    let FormValid = true;

    if (addnotask.taskName.length === 0) {
      FormValid = false;
      setTaskTitleError(true);
    }
    if (!projectname) {
      FormValid = false;
      setTaskProjNameError(true);
    }
    if (addnotask.taskdescription.length === 0) {
      FormValid = false;
      setTaskDescError(true);
    }
    // if (!categoryname) {
    //   FormValid = false;
    //   setTaskCategoryError(true);
    // }
    if (!taskpriority) {
      FormValid = false;
      setTaskPriorityError(true);
    }
    if (!departmentName) {
      FormValid = false;
      setDepartmentError(true);
    }
    if (subDeptOptions.length > 0 && !subDepartment) {
      FormValid = false;
      setSubDepartmentError(true);
    }
    if (addnotask.proposedstartdate.length === 0) {
      FormValid = false;
      setTaskProposedDtError(true);
    }
    if (addnotask.proposedenddate.length === 0) {
      FormValid = false;
      setTaskProposedEndDtError(true);
    }
    if (addnotask.initialEstimateHr.length === 0) {
      FormValid = false;
      setTaskInitialEstimateHrError(true);
    }
    if (addnotask.initialEstimateMinutes.length === 0) {
      FormValid = false;
      setInitialMinuteErr(true);
    }

    return FormValid;
  };

  const handlerData = (e) => {
    let name = e.target.name;
    let value = e.target.value;
    setAddNoTask({ ...addnotask, [name]: value });
  };

  const AddTaskSuccess = () => {
    toast.success("Assigned Task Successfully", {
      position: toast.POSITION.TOP_RIGHT,
      autoClose: 1000,
      toastId: "assign-task-success",
    });
  };

  const InitialHrMinute = () => {
    toast.error(
      "00 hours and 00 minutes at the same time are not permitted, please choose an acceptable time.",
      {
        position: toast.POSITION.TOP_RIGHT,
        autoClose: 1000,
        toastId: "initial-hr-minute-error",
      }
    );
  };

  const handleSubmit = () => {
    setTaskTitleError(false);
    setTaskDescError(false);
    setTaskCategoryError(false);
    setTaskProjNameError(false);
    setTaskPriorityError(false);
    setTaskProposedDtError(false);
    setTaskProposedEndDtError(false);
    setTaskInitialEstimateHrError(false);
    setInitialMinuteErr(false);
    setDepartmentError(false);
    setSubDepartmentError(false);

    if (handlerValidate()) {
      if (parseFloat(addnotask.initialEstimateHr) === 0 && parseFloat(addnotask.initialEstimateMinutes) === 0) {
        InitialHrMinute();
        return;
      }
      const start = new Date(addnotask.proposedstartdate);
      const end = new Date(addnotask.proposedenddate);

      const hr = parseInt(addnotask.initialEstimateHr || 0);
      const min = parseInt(addnotask.initialEstimateMinutes || 0);

      const diffDays =
        Math.ceil((end - start) / (1000 * 60 * 60 * 24)) + 1;

      const totalMinutes = hr * 60 + min;
      const maxMinutes = diffDays * 8 * 60;

      if (totalMinutes > maxMinutes) {
        toast.error(
          `Maximum allowed is ${diffDays * 8} hours for ${diffDays} day(s).`
        );
        return;
      }

      if (diffDays === 1) {
        if (hr > 8 || (hr === 8 && min > 0)) {
          toast.error("For one day, max allowed is 8 hr 00 min.");
          return;
        }
      }
      const payload = {
        empId: data?.empId,
        taskName: addnotask?.taskName,
        taskDescription: addnotask?.taskdescription,
        taskPriority: taskpriority?.value,

        department_id: departmentName?.value,
        departmentName: departmentName?.label,
        taskDepartmentId: departmentName?.value,
        taskDepartmentName: departmentName?.label,

        subDepartmentId: subDepartment?.value || "",
        subDepartmentName: subDepartment?.label || "",

        projectId: projectname.value,
        projectName: projectname.label,
        AssignTask: "",
        assignBy_id: loginUserData?.empId,
        assignBy_Name: `${loginUserData.firstName} ${loginUserData.lastName}`,
        resource_id: data?.empId,
        resourceName: `${data.firstName} ${data.lastName}`,
        categoryOfName: categoryname?.label || "",
        category_id: categoryname?.value || "",

        proposedStartDate: new Date(addnotask.proposedstartdate)
          .toISOString()
          .split("T")[0],
        proposedEndDate: new Date(addnotask.proposedenddate)
          .toISOString()
          .split("T")[0],

        initialEstimateHr: addnotask.initialEstimateHr,
        initialEstimateMinutes: addnotask.initialEstimateMinutes,
        estimateHr: "",
        status: "pending",
        logStatus: {
          status: "pending",
          resource_id: data?.empId,
          resourceName: `${data.firstName} ${data.lastName}`,
        },
      };

      axios
        .post(process.env.REACT_APP_BASE_URL + "/task/addTask", payload)
        .then((res) => {
          AddTaskSuccess();
          setTimeout(() => {
            close();
            navigate(`/${loginUserData?.resourceType}/employee-task`);
          }, 1000);
        })
        .catch((err) => {
          console.log("Error", err);
        });
    }
  };

  return (
    <>
      <Modal
        show={show}
        onHide={close}
        size="lg"
        centered
        backdrop="static"
        keyboard={false}
      >
        <Modal.Header closeButton className="mngmodelheader">
          <Modal.Title>
            <h5>Assign Task</h5>
          </Modal.Title>
        </Modal.Header>

        <Modal.Body size="lg">
          {/* Row 1 */}
          <Row className="mb-4">
            <Col sm={12} md={4}>
              <Form.Group>
                <Form.Label>Assign To</Form.Label>
                <Form.Control
                  value={`${data?.firstName} ${data?.lastName}`}
                  readOnly
                />
              </Form.Group>
            </Col>
            <Col sm={12} md={4}>
              <Form.Group>
                <Form.Label>
                  Department Name <span className="requiredfield">*</span>
                </Form.Label>
                <Select
                  isMulti={false}
                  isSearchable={true}
                  value={departmentName}
                  options={userDepartmentName}
                  onChange={(option) => {
                    setDepartmentName(option);
                    setSubDepartment(null);
                    setDepartmentError(false);
                  }}
                />
              </Form.Group>
              {departmentError && (
                <p className="errMsg">
                  <Icon.ExclamationTriangle className="me-2" />
                  Required Field
                </p>
              )}
            </Col>

            <Col sm={12} md={4}>
              <Form.Group>
                <Form.Label>
                  Sub Department Name
                  {subDeptOptions.length > 0 && (
                    <span className="requiredfield">*</span>
                  )}
                </Form.Label>
                <Select
                  isMulti={false}
                  isSearchable={true}
                  value={subDepartment}
                  options={subDeptOptions}
                  isDisabled={!departmentName || subDeptOptions.length === 0}
                  onChange={(option) => {
                    setSubDepartment(option);
                    setCategoryname(null);
                    setSubDepartmentError(false);
                  }}
                />
              </Form.Group>
              {subDepartmentError && (
                <p className="errMsg">
                  <Icon.ExclamationTriangle className="me-2" />
                  Required Field
                </p>
              )}
            </Col>
          </Row>

          {/* Row 2 */}
          <Row className="mb-3">
            <Col sm={12} md={6}>
              <Form.Group>
                <Form.Label>
                  Task Title <span className="requiredfield">*</span>
                </Form.Label>
                <Form.Control
                  placeholder="Task Name"
                  name="taskName"
                  value={addnotask.taskName}
                  onChange={(e) => {
                    if (
                      !e.target.value.match(
                        /[+@#$&%!~=^_:(){}\[\]*.|//\-/?<>,;`'""/\\]/
                      ) &&
                      e.target.value.trim()
                    ) {
                      handlerData(e);
                    } else if (e.target.value.length === 0) {
                      handlerData(e);
                    }
                    setTaskTitleError(false);
                  }}
                />
                {tasktitleerror && (
                  <p className="errMsg">
                    <Icon.ExclamationTriangle className="me-2" />
                    Required Field
                  </p>
                )}
              </Form.Group>
            </Col>

            <Col sm={12} md={6}>
              <Form.Label>
                Task Priority <span className="requiredfield">*</span>
              </Form.Label>
              <Select
                isMulti={false}
                isSearchable={true}
                value={taskpriority}
                options={taskPriorityOptions}
                onChange={(option) => {
                  setTaskpriority(option);
                  setTaskPriorityError(false);
                }}
              />
              {taskpriorityerror && (
                <p className="errMsg">
                  <Icon.ExclamationTriangle className="me-2" />
                  Required Field
                </p>
              )}
            </Col>
          </Row>

          {/* Row 3 */}
          <Row className="mb-3">
            <Col sm={12}>
              <Form.Group>
                <Form.Label>
                  Task Description <span className="requiredfield">*</span>
                </Form.Label>
                <Form.Control
                  as="textarea"
                  placeholder="Task Description"
                  name="taskdescription"
                  value={addnotask.taskdescription}
                  onChange={(e) => {
                    if (e.target.value.trim()) {
                      handlerData(e);
                    } else if (e.target.value.length === 0) {
                      handlerData(e);
                    }
                    setTaskDescError(false);
                  }}
                />
              </Form.Group>
              {taskdescerror && (
                <p className="errMsg">
                  <Icon.ExclamationTriangle className="me-2" />
                  Required Field
                </p>
              )}
            </Col>
          </Row>

          {/* Row 4 */}
          <Row className="mb-4">
            <Col sm={12} md={6}>
              <Form.Group>
                <Form.Label>
                  Project Name <span className="requiredfield">*</span>
                </Form.Label>
                <Select
                  isMulti={false}
                  isSearchable={true}
                  value={projectname}
                  options={projectOptions}
                  onChange={(option) => {
                    setProjectname(option);
                    setTaskProjNameError(false);
                  }}
                />
              </Form.Group>
              {taskprojnameerror && (
                <p className="errMsg">
                  <Icon.ExclamationTriangle className="me-2" />
                  Required Field
                </p>
              )}
            </Col>

            <Col sm={12} md={6}>
              <Form.Group>
                <Form.Label>
                  Category Name
                  {/* <span className="requiredfield">*</span> */}
                </Form.Label>
                <Select
                  isMulti={false}
                  isSearchable={true}
                  value={categoryname}
                  options={allCategoriesOptions}
                  isDisabled={!departmentName || !subDepartment}
                  onChange={(option) => {
                    setCategoryname(option);
                    setTaskCategoryError(false);
                  }}
                />
              </Form.Group>
              {/* {taskcategoryError && (
                <p className="errMsg">
                  <Icon.ExclamationTriangle className="me-2" />
                  Required Field
                </p>
              )} */}
            </Col>
          </Row>

          {/* Row 5 */}
          <Row className="mb-4">
            <Col sm={12} md={3}>
              <Form.Group className="w-100">
                <Form.Label>
                  Proposed Start date <span className="requiredfield">*</span>
                </Form.Label>
                <Form.Control
                  type="date"
                  name="proposedstartdate"
                  min={new Date().toISOString().split("T")[0]}
                  onKeyDown={(event) => event.preventDefault()}
                  value={
                    addnotask?.proposedstartdate
                      ? new Date(addnotask?.proposedstartdate)
                        .toISOString()
                        .split("T")[0]
                      : ""
                  }
                  onChange={(e) => {
                    handlerData(e);
                    setTaskProposedDtError(false);
                  }}
                />
              </Form.Group>
              {taskproposeddterror && (
                <p className="errMsg">
                  <Icon.ExclamationTriangle className="me-2" />
                  Required Field
                </p>
              )}
            </Col>

            <Col sm={12} md={3}>
              <Form.Group style={{ width: "100%" }}>
                <Form.Label>
                  Proposed End date <span className="requiredfield">*</span>
                </Form.Label>
                <Form.Control
                  type="date"
                  name="proposedenddate"
                  value={
                    addnotask?.proposedenddate
                      ? new Date(addnotask?.proposedenddate)
                        .toISOString()
                        .split("T")[0]
                      : ""
                  }
                  min={addnotask.proposedstartdate}
                  disabled={addnotask?.proposedstartdate?.length === 0}
                  onChange={(e) => {
                    handlerData(e);
                    setTaskProposedEndDtError(false);
                  }}
                />
              </Form.Group>
              {taskproposedenddterror && (
                <p className="errMsg">
                  <Icon.ExclamationTriangle className="me-2" />
                  Required Field
                </p>
              )}
            </Col>

            <Col sm={12} md={3}>
              <Form.Group style={{ width: "100%" }}>
                <Form.Label>
                  Initial Estimate(Hours)
                  <span className="requiredfield">*</span>
                </Form.Label>
                <Form.Control
                  type="text"
                  placeholder="Initial Estimate Hr"
                  name="initialEstimateHr"
                  value={addnotask?.initialEstimateHr}
                  onChange={(e) => {
                    if (
                      /^[0-9]*(\.[0-9]*)?$/.test(e.target.value) &&
                      e.target.value.length <= 4
                    ) {
                      handlerData(e);
                    } else if (e.target.value.length === 0) {
                      handlerData(e);
                    }
                    setTaskInitialEstimateHrError(false);
                  }}
                />
              </Form.Group>
              {taskinitialestihrerror && (
                <p className="errMsg">
                  <Icon.ExclamationTriangle className="me-2" />
                  Required Field
                </p>
              )}
            </Col>

            <Col sm={12} md={3}>
              <Form.Group style={{ width: "100%" }}>
                <Form.Label>
                  Initial Minutes <span className="requiredfield">*</span>
                </Form.Label>
                <Form.Control
                  type="text"
                  placeholder="Initial Minutes"
                  name="initialEstimateMinutes"
                  value={addnotask?.initialEstimateMinutes}
                  onChange={(e) => {
                    if (
                      /^[0-9]{0,2}$/.test(e.target.value) &&
                      e.target.value >= 0 &&
                      e.target.value <= 59
                    ) {
                      handlerData(e);
                    } else if (e.target.value > 59) {
                      toast.error("Please enter a value between 0 and 59.");
                    } else if (e.target.value.length === 0) {
                      handlerData(e);
                    }
                    setInitialMinuteErr(false);
                  }}
                />
              </Form.Group>
              {initialminuteErr && (
                <p className="errMsg">
                  <Icon.ExclamationTriangle className="me-2" />
                  Required Field
                </p>
              )}
            </Col>
          </Row>
        </Modal.Body>

        <Modal.Footer className="text-center mt-4">
          <Button className="primaryBtn" onClick={handleSubmit}>
            <Icon.PersonAdd className="me-2" /> Create Task
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
};
